import {
  BB_INTEGRATION_CONFIG_SAVED,
  BB_INTEGRATION_CONFIG_SAVED_SCOPE,
  INTEGRATION_CONFIG_SAVED_VERSION,
  IntegrationId,
} from '../constants/webViewIntegrationConfig'
import { postHostPayload } from './reactNativeWebView'

export function notifyIntegrationConfigSaved(
  integration: IntegrationId,
  extra?: Record<string, unknown>,
): boolean {
  return postHostPayload({
    type: BB_INTEGRATION_CONFIG_SAVED,
    scope: BB_INTEGRATION_CONFIG_SAVED_SCOPE,
    version: INTEGRATION_CONFIG_SAVED_VERSION,
    integration,
    ...extra,
  })
}
